export default __webpack_public_path__ + "static/media/Award_Statue_Character_Gold.256.96866da1.png";